@if (!isAdmin) {
<div class="mx-auto bg-white rounded shadow-sm overflow-hidden dark:border-1 dark:border-[#d7dde2]!">
  <div class="relative h-auto w-full">
    <img src="assets/images/backgrounds/company-profile-banner.png" alt="Cover" class="w-full h-24 object-cover opacity-95" />

    @if (isAdmin) {
      <button type="button" (click)="close()"
        class="group absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full cursor-pointer
          bg-white/20 border border-white/30 backdrop-blur-sm hover:bg-white/90 transition-colors">
        <i-tabler name="x" class="icon-18 d-flex text-white! group-hover:text-slate-700! transition-colors" />
      </button>
    }

    <div class="absolute top-[100%] -translate-y-[50%] left-4 sm:left-10">
      <div class="bg-white p-1 rounded-full">
        <div class="size-20 sm:size-24 rounded-full border-4 border-white bg-gradient-to-br from-green-500 to-blue-500 flex items-center justify-center">
          <span class="text-white text-2xl font-bold uppercase">{{ firstCharacterCompany }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="h-20 dark:bg-[var(--mat-card-elevated-container-color)]!">
    <div class="min-w-0 pt-2! ml-28! pr-4 sm:ml-38!">
      <h3 class="truncate f-s-16 font-medium">{{ company?.name }}</h3>
      <p class="truncate f-s-12 mt-[2px] text-slate-550">{{ company?.email }}</p>
    </div>
  </div>
</div>
}

<div class="rounded shadow-sm overflow-hidden dark:border-1 dark:border-[#d7dde2]!" [class.mt-4]="!isAdmin">
  <mat-card [hidden]="!company" class="w-full mb-0!">
    <app-dynamic-form
      #companyDetailForm
      [formGroup]="companyForm"
      [formConfigs]="formConfigs"
      [onSubmit]="onSubmit"
      [spinLoader]="spinLoader"
    />
  </mat-card>
</div>
